module.exports = __webpack_public_path__ + "static/media/back.b695b1f0.svg";